// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9cdb7f93","667":"bf2fb3a8","977":"5a16dd68"}[chunkId] + ".chunk.js";
};